<template>
	<div class="m-grid__item m-grid__item--fluid m-wrapper">
		<router-view />
	</div>
</template>

<script>
	export default {
		
	}
</script>